import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useFormContext } from "react-hook-form";
import Tooltip from './Tooltip';

type CheckBoxFieldProps = {
    className?: string;
    label: string;
    name: string;
    defaultChecked?: boolean;
    disabled?: boolean;
    required?: boolean;
    tooltipBody?: () => JSX.Element;
    onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function CheckBoxField({ className, label, name, defaultChecked, disabled, tooltipBody, required, onClick, onChange }: CheckBoxFieldProps) {

    const { register, formState: { errors } } = useFormContext();

    const validations = {
        required: required
    };


    return (
        <FormGroup className={className}>
            {tooltipBody &&
                <Tooltip tooltipBody={tooltipBody()} />
            }
            <Label htmlFor={name}>
                <input {...register(name, validations)}
                    className="checkbox-input"
                    type="checkbox"
                    name={name}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    onClick={onClick}
                    onChange={onChange}
                />
                {label}
            </Label>
            <div className="form-error-wrapper">
                {errors[name]?.type === 'required' && 'This is a required field'}
            </div>
        </FormGroup>
    );
}
export default CheckBoxField;
